import { render, staticRenderFns } from "./video_bill_en.vue?vue&type=template&id=3bdcbaf4&scoped=true&"
import script from "./video_bill_en.vue?vue&type=script&lang=js&"
export * from "./video_bill_en.vue?vue&type=script&lang=js&"
import style0 from "./video_bill_en.vue?vue&type=style&index=0&id=3bdcbaf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcbaf4",
  null
  
)

export default component.exports